<div class="header">
  <span class="header__title lx-section-title">Bulk Import</span>
</div>

<div class="input-container">
  <div class="lx-label">Serial Numbers</div>
  <div class="input-container__entities">
    <textarea
      id="serialNumbersString"
      name="serialNumbersString"
      placeholder="Enter serial numbers"
      [(ngModel)]="serialNumbersString"></textarea>
  </div>
  <div class="lx-label">Groups</div>
  <div class="input-container__entities">
    <textarea
      id="gruopIdsString"
      name="groupIdsString"
      placeholder="Enter Group IDs"
      [(ngModel)]="groupIdsString"></textarea>
  </div>
</div>

<div class="footer">
  <button
    class="footer__button-container lx-btn lx-btn-secondary"
    id="back"
    (click)="close()">
    Back
  </button>
  <button
    class="footer__button-container lx-btn lx-btn-primary"
    id="next"
    (click)="next()">
    Import
  </button>
</div>
